import { createUseStyles } from 'react-jss';

export default createUseStyles({
  userTypesContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridRowGap: '20px',
    marginBottom: '20px',
    gridTemplateRows: '600px 600px',
    '& > *:nth-of-type(n+3)': {
      gridColumn: '1/3',
    },
    '@media(max-width: 900px)': {
      gridTemplateColumns: '1fr',
      gridTemplateRows: '400px 400px 400px',
      '& > *:nth-of-type(n+3)': {
        gridColumn: '1/2',
      },
      paddingBottom: '20px'
    }
  },
});
